/** 已关闭（含进行中主动收起）的后台任务 id，按账户写入 localStorage（刷新后仍隐藏） */

const STORAGE_PREFIX = "c456.background_tasks.dismissed.";

export function backgroundTasksDismissedStorageKey(accountId: string): string {
  return `${STORAGE_PREFIX}${accountId}`;
}

function isPositiveInt(value: unknown): value is number {
  return typeof value === "number" && Number.isInteger(value) && value > 0;
}

/** 读取某账户已 dismiss 的任务 id；无效/缺失时返回空集 */
export function readDismissedTaskIds(accountId: string): Set<number> {
  if (!accountId || typeof window === "undefined") return new Set();
  try {
    const raw = window.localStorage.getItem(backgroundTasksDismissedStorageKey(accountId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter(isPositiveInt));
  } catch {
    return new Set();
  }
}

/** 持久化已 dismiss 的任务 id；空集则清除该 key */
export function writeDismissedTaskIds(accountId: string, ids: Set<number>): void {
  if (!accountId || typeof window === "undefined") return;
  try {
    const key = backgroundTasksDismissedStorageKey(accountId);
    if (ids.size === 0) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, JSON.stringify([...ids]));
  } catch {
    // 配额满 / 隐私模式等忽略
  }
}

/**
 * 只保留仍出现在 catch-up 任务列表中的 dismiss id，避免 localStorage 无限增长。
 * 已过 TTL、不再返回的已完成任务可安全丢弃。
 */
export function pruneDismissedTaskIds(dismissed: Set<number>, knownTaskIds: Iterable<number>): Set<number> {
  const known = knownTaskIds instanceof Set ? knownTaskIds : new Set(knownTaskIds);
  if (known.size === 0) return new Set();
  const next = new Set<number>();
  for (const id of dismissed) {
    if (known.has(id)) next.add(id);
  }
  return next;
}
